export enum Role {
  RESTRUCTURING = 'ROLE_RESTRUCTURING',
  ADMIN_ENTITY = 'ROLE_APP_ADMIN_ENTITY_FULL',
  ENTITY_INVOICES = 'ROLE_INVOICE_ENTITY',
  ENTITY_DOCUMENTS = 'ROLE_DOCUMENT_ENTITY_SHOW',
  REFRESH_PURCHASE_RATE = 'ROLE_REFRESH_PURCHASE_RATE',
  PRODUCT_TYPE_RESIDUAL_PERCENT_FORCE = 'ROLE_PRODUCT_TYPE_RESIDUAL_PERCENT_FORCE',
  CONTRACT_GUARANTEES = 'ROLE_CONTRACT_GUARANTEES',
  ENHANCED_SIGN = 'ROLE_ENHANCED_SIGN',
  PRODUCT_TYPE_RESIDUAL_PERCENT_MAX_FORCE = 'ROLE_PRODUCT_TYPE_RESIDUAL_PERCENT_MAX_FORCE',
  DEMANDS = 'ROLE_DEMANDS',
  DEMAND = 'ROLE_DEMAND',
  INVOICE_SUPPLIER_SHOW = 'ROLE_INVOICE_SUPPLIER_SHOW',
  INVOICE_CLIENT_SHOW = 'ROLE_INVOICE_CLIENT_SHOW',
  INVOICE_REFINANCER_SHOW = 'ROLE_INVOICE_REFINANCER_SHOW',
  OUTSTANDING_SHOW = 'ROLE_OUTSTANDING_SHOW',
  OUTSTANDING_SUPPLIER_SHOW = 'ROLE_OUTSTANDING_SUPPLIER_SHOW',
  OUTSTANDING_REFINANCER_SHOW = 'ROLE_OUTSTANDING_REFINANCER_SHOW',
  ROLE_VIEW_OTHER = 'ROLE_VIEW_OTHER',
  RENT_EDIT = 'ROLE_RENT_EDIT',
}

export default Role
